import { render, staticRenderFns } from "./Documentsform.vue?vue&type=template&id=3301d392&scoped=true"
import script from "./Documentsform.vue?vue&type=script&lang=js"
export * from "./Documentsform.vue?vue&type=script&lang=js"
import style0 from "./Documentsform.vue?vue&type=style&index=0&id=3301d392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3301d392",
  null
  
)

export default component.exports